import React from 'react';
import classNames from 'classnames';

import E100Button, {
  IPropTypes
} from 'e100-react-components/lib/components/Button';

import { useStyles } from './styles';

export const Button = ({
  mobileButton = false,
  classes = {},
  variant,
  ...props
}: ButtonProps) => {
  const innerClasses = useStyles({ mobileButton, variant });

  return (
    <E100Button
      {...props}
      classes={{
        ...classes,
        root: classNames({
          [innerClasses.root]: true,
          [classes.root || '']: true
        })
      }}
    />
  );
};

export interface ButtonProps extends Omit<
  IPropTypes,
  'variant'
> {
  mobileButton?: boolean;
  variant?: IPropTypes['variant'] | 'filled'
}